<template>
  <div class="canvasBox">
    <div class="spinnerFourBox" :style="spinnerStyle"></div>
    <div class="contantBoxText"><p>{{ loadingText }}</p></div>
  </div>
</template>

<script>
export default {
  props: {
    loadingText: {
      default: '正在加载中...'
    },
    spinnerStyle: {}
  }
}
</script>


<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.canvasBox {
  text-align: center;
}
.spinnerFourBox {
  display: inline-block;
  animation: spinnerFour 1s linear infinite;
  border: solid 5px #0e213e;
  border-top: solid 5px #1988ff;
  border-radius: 100%;
  width: 30px;
  height: 30px;
}

.contantBoxText {
  font-size: 12px;
  color: white;
  opacity: 0.6;
  padding-top: 5px;
}

@keyframes spinnerFour {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/businessModule/loading1.vue